import { useEffect, useRef } from 'react';
import LicitacionesList from '../../components/LicitacionesList/LicitacionesList';
import { Filters } from '../../components/Filters/Filters';
import EmptyState from '../../components/EmptyState/EmptyState';
import { useLicitacionesStore } from '../../store/licitacionesStore';
import { useFiltersStore } from '../../store/filtersStore';

const Home = () => {
  const { licitaciones, page, limit, total, fetchLicitaciones } = useLicitacionesStore();
  const {
    activeStatusFilters,
    searchTerm,
    postuladoFilter,
    adjudicadoFilter,
    noLeidasFilter,
    fechaCierreDesde,
    fechaCierreHasta,
    fechaPublicacionDesde,
    fechaPublicacionHasta,
  } = useFiltersStore();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    fetchLicitaciones({ silent: true, page: 1, limit });
  }, [
    activeStatusFilters,
    searchTerm,
    postuladoFilter,
    adjudicadoFilter,
    noLeidasFilter,
    fechaCierreDesde,
    fechaCierreHasta,
    fechaPublicacionDesde,
    fechaPublicacionHasta,
  ]);

  const handlePageChange = (newPage: number, newLimit: number) => {
    fetchLicitaciones({ silent: true, page: newPage, limit: newLimit });
  };

  if (licitaciones.length === 0 && total === 0) {
    return (
      <div>
        <Filters
          onRefresh={() => fetchLicitaciones({ page: 1, limit: 20 })}
          refreshTooltip="Actualizar licitaciones"
          entityType="licitaciones"
        />
        <EmptyState
          title="No hay licitaciones para mostrar"
          subtitle="No se encontraron licitaciones disponibles en este momento. Los datos se actualizan automáticamente."
        />
      </div>
    );
  }

  return (
    <div>
      <Filters
        onRefresh={() => fetchLicitaciones({ page: 1, limit: 20 })}
        refreshTooltip="Actualizar licitaciones"
        entityType="licitaciones"
      />
      <LicitacionesList
        data={licitaciones}
        emptyMessage="No se encontraron licitaciones"
        detailBasePath="/licitacion"
        entityType="licitaciones"
        page={page}
        limit={limit}
        total={total}
        onPageChange={handlePageChange}
        onRefresh={() => fetchLicitaciones({ silent: true, page, limit })}
      />
    </div>
  );
};

export default Home;
